import styled from 'styled-components';
import { Label } from '../../../components/uielements';
import { palette } from 'styled-theme';

export const Container = styled.div`
  background-color: ${palette('background', 0)};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
`;

export const TopButton = styled.button`
  background-color: #41e4c9;
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  font-size: 0.875rem;
  position: fixed;
  right: 0;
  top: 0;
  font-family: JetBrains Mono Regular;
`;

export const Main = styled.main`
  background: #fafafa;
  padding: 2rem;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
`;

export const Title = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  margin-bottom: 1.5rem;
  text-transform: uppercase;
`;

export const ReportContent = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: ${palette('text', 1)};
  margin-bottom: 2rem;
  p {
    margin-bottom: 1rem;
    font-family: 'Inter', monospace;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  margin-top: 30px;
`;

export const LinksContainer = styled.div`
  display: flex;
  gap: 1.8rem;
`;

export const LinkButton = styled.a`
  color: ${palette('text', 1)};
  text-decoration: underline;
  cursor: pointer;
  font-family: 'Inter';
  font-size: 16px;
  text-underline-offset: 4px;
`;
